import React from 'react';
import { Edge, FlippedEdge } from './styles';
import { ScallopedEdgeType } from './types';

/**
 * Creates a scalloped edge/border.
 *
 * To use, place the edge in a container that has the style: `position: relative`.
 * Either as the first or last child. Use the `isFlipped` prop to flip the
 * edge according to style and optional `color` to use other than white.
 */
export const ScallopedEdge: React.FC<ScallopedEdgeType> = (props) => {
  const { className, color, isFlipped } = props;
  const sharedProps = {
    className,
    color,
  };
  return isFlipped ? <FlippedEdge {...sharedProps} /> : <Edge {...sharedProps} />;
};
